import { render, staticRenderFns } from "./vhcInsurance.vue?vue&type=template&id=34f5f748&scoped=true&"
import script from "./vhcInsurance.vue?vue&type=script&lang=js&"
export * from "./vhcInsurance.vue?vue&type=script&lang=js&"
import style0 from "./vhcInsurance.vue?vue&type=style&index=0&id=34f5f748&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f5f748",
  null
  
)

export default component.exports